import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { filter, map, switchMap, tap } from 'rxjs';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.authInitialized$.pipe(
    filter(initialized => initialized),
    switchMap(() => auth.user$),
    map(user => !!user),
    tap(isLoggedIn => {
      if (!isLoggedIn) {
        // Carry the requested page through the login flow (incl. the magic-link email
        // roundtrip) so an /account bookmark still lands on /account after signing in.
        router.navigate(['/authentication/login'], {
          queryParams: { returnUrl: state.url },
        });
      }
    })
  );
};
